/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 20210113 11:15:08
 * @FilePath: \mrc-ess-fronted\src\plugins\theme.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-09 13:15:03
 */
const theme = {
  themes: {
    light: {
      primary: {
        base: "#0F46C1",
        darken1: "#0D42B5",
        darken2: "#0A3EA5",
        darken3: "#083998",
        darken4: "#043381",
        lighten1: "#4575D6",
        lighten2: "#739CE8",
        lighten3: "#A6C4F9",
        lighten4: "#C6DBFD",
        lighten5: "#E5EEFF",
      },
      pink: "#fC7DC2", //排班格子star
    },
    dark: {
      primary: {
        base: "#0F46C1",
        darken1: "#0D42B5",
        darken2: "#0A3EA5",
        darken3: "#083998",
        darken4: "#043381",
        lighten1: "#4575D6",
        lighten2: "#739CE8",
        lighten3: "#A6C4F9",
        lighten4: "#C6DBFD",
        lighten5: "#E5EEFF",
      },
      pink: "#fC7DC2", //排班格子star
    },
  },
};
//variations=false的时候用
// const theme = {
//   themes: {
//     light: {
//       primary: "#0F46C1",
//       pink: "#fC7DC2", //排班格子star
//     },
//     dark: {
//       primary: "#0F46C1",
//       pink: "#fC7DC2", //排班格子star
//     },
//   },
// };
export default theme;
